/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountDebondingInfo,
    AccountDebondingInfoFromJSON,
    AccountDebondingInfoFromJSONTyped,
    AccountDebondingInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountDebondingResponse
 */
export interface AccountDebondingResponse {
    /**
     * 
     * @type {Array<AccountDebondingInfo>}
     * @memberof AccountDebondingResponse
     */
    list: Array<AccountDebondingInfo>;
    /**
     * 
     * @type {number}
     * @memberof AccountDebondingResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDebondingResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDebondingResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDebondingResponse
     */
    totalSize?: number;
}

export function AccountDebondingResponseFromJSON(json: any): AccountDebondingResponse {
    return AccountDebondingResponseFromJSONTyped(json, false);
}

export function AccountDebondingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDebondingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AccountDebondingInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function AccountDebondingResponseToJSON(value?: AccountDebondingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AccountDebondingInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


